import React, { createContext, useContext } from "react";

const GeneralStyleContext = createContext();

export const GeneralStyleProvider = ({ children ,value}) => {
  return (
    <GeneralStyleContext.Provider value={value}>
      {children}
    </GeneralStyleContext.Provider>
  );
};

export const useGeneralStyle = () => useContext(GeneralStyleContext);
